import campaignTemplate from './campaignList.html';

const campaignList = {
    bindings: {
        parentCampaignId: '=?',
        hideDeleteButton: '=?',
        search: '=',
        type: '=',
        campaignsData: '=',
        taskStarted: '&',
        taskEnded: '&',
        call: '&',
        currencies: '=',
    },
    template: campaignTemplate,

    controller: function (ApiCampaigns, MessageBox, $scope, $state) {
        this.filter = {};

        $scope.$watch(
            () => {
                return this.campaignsData;
            },
            () => {
                this.init();
            }
        );

        this.$onInit = () => {
            this.init();
        };

        this.init = function () {
            if (this.campaignsData) this.campaigns = this.campaignsData;
            // assign data from external source
            else this.selectData(); // get data through internal functions
        };

        this.searchCampaigns = function (text) {
            this.search = text;
        };

        this.getAllCampaigns = function () {
            this.taskStarted();
            ApiCampaigns.getCampaigns().then((campaigns) => {
                this.campaigns = campaigns || [];
                this.taskEnded();
                return campaigns;
            });
        };

        this.getAllChildCampaigns = function () {
            this.taskStarted();
            ApiCampaigns.getAllChildCampaigns().then((campaigns) => {
                this.campaigns = campaigns || [];
                this.taskEnded();
            });
        };

        this.getAllMotherCampaigns = function () {
            this.taskStarted();
            ApiCampaigns.getAllMotherCampaigns().then((campaigns) => {
                this.campaigns = campaigns || [];
                this.taskEnded();
            });
        };

        this.getCampaignChildren = function (campaignId) {
            this.taskStarted();
            ApiCampaigns.getCampaignChildren(campaignId).then((campaigns) => {
                this.campaigns = campaigns || [];
                this.taskEnded();
            });
        };

        this.removeCampaign = function (campaign) {
            this.taskStarted();
            ApiCampaigns.deleteCampaign(campaign.campaignId).then(
                (res) => {
                    this.taskEnded();
                    if (res === undefined) return;
                    this.MessageBox.showSuccessMessage('CAMPAIGN', 'DELETE');
                    this.campaigns.splice(this.campaigns.indexOf(campaign), 1);
                },
                (error) => {
                    this.taskEnded();
                }
            );
        };

        this.removeChildCampaign = function (removedChild, $event) {
            $event.preventDefault();
            $event.stopPropagation();
            if (!removedChild) return;
            this.taskStarted();
            let filteredChildren = this.campaigns.filter(function (c) {
                return c.campaignId != removedChild.campaignId;
            });
            let childrenIds = filteredChildren.map((c) => c.campaignId);
            ApiCampaigns.addChildren(this.parentCampaignId, childrenIds).then(
                (response) => {
                    this.taskEnded();
                    if (angular.isUndefined(response)) return;
                    $state.reload();
                    this.campaigns.splice(
                        this.campaigns.indexOf(removedChild),
                        1
                    );
                    MessageBox.showSuccessMessage('CAMPAIGN_CHILD', 'REMOVE');
                }
            );
        };

        this.selectData = function () {
            switch (this.type) {
                case 'children':
                    this.getAllChildCampaigns();
                    break;
                case 'mother':
                    this.getAllMotherCampaigns();
                    break;
                default:
            }
        };

        this.getCurrencySymbol = function (currencyShortName) {
            if (!this.currencies || !currencyShortName) return '';

            var currency = this.currencies.find(function (currency) {
                return currency.shortName === currencyShortName;
            });

            return currency && currency.symbol;
        };

        this.getCampaignUrl = (campaignId) => {
            return $state.href('campaignDetail', {
                campaignId: campaignId,
                sortOrder: null,
            });
        };
    },
};

export default campaignList;



/** WEBPACK FOOTER **
 ** ./src/app/directives/campaignList/campaignList.js
 **/